import { render, staticRenderFns } from "./TeachingVideo.vue?vue&type=template&id=6c5424ce&scoped=true&"
import script from "./TeachingVideo.vue?vue&type=script&lang=js&"
export * from "./TeachingVideo.vue?vue&type=script&lang=js&"
import style0 from "./TeachingVideo.vue?vue&type=style&index=0&id=6c5424ce&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c5424ce",
  null
  
)

export default component.exports